// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import './Card.scss';
import CircleLoader from '../../../Util/CircleLoader/CircleLoader';
import VoteCollection from '../VoteCollection/VoteCollection';
import TimeAgo from '../../../Util/TimeAgo/TimeAgo';

@inject('userStore')
@observer class Card extends Component<any, any> {

	render() {
		return (
			<div className="question">			
				{this.props.question ? 
					<div className="question-body">
						<h2>{this.props.question.name}</h2>
						<p><b>by {this.props.question.user.username}</b> <TimeAgo date={this.props.question.created_at} /></p> 
						<VoteCollection question={this.props.question} key={this.props.userStore.user}/>
					</div>
					:
					<CircleLoader size={20}/>
					}
			</div>
		)
	}
}

export default Card;

